import { render, staticRenderFns } from "./SettingAreaCmp.vue?vue&type=template&id=4a109cd8&scoped=true"
import script from "./SettingAreaCmp.vue?vue&type=script&lang=js"
export * from "./SettingAreaCmp.vue?vue&type=script&lang=js"
import style0 from "./SettingAreaCmp.vue?vue&type=style&index=0&id=4a109cd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a109cd8",
  null
  
)

export default component.exports